<template>
  <div
    id="idPopupRename"
    class="modal-rename"
  >
    <p class="modal-rename__label">Rename</p>
    <b-form-group>
      <j-input
        ref="inputName"
        :class="{'error-input' : $v.name.$error}"
        v-model="name"
        placeholder="Input name"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <button
            class="button-border mr-2"
            type="button"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            class="button-blue"
            type="button"
            @click="handleRename"
          >
            Set
          </button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    dataSelected: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      name: '',
      prevName: '',
    };
  },

  created() {
    if (this.dataSelected) {
      this.name = this.dataSelected.name;
      this.prevName = this.dataSelected.name;
    }
  },

  mounted() {
    const input = this.$refs.inputName.$el.getElementsByTagName('input')[0];
    input.focus();
  },

  methods: {
    handleRename() {
      this.$v.name.$touch();
      if (!this.$v.name.$error) {
        if (this.name !== this.prevName) this.$emit('rename', this.name);
        else this.$emit('close');
      }
    },
  },

  validations: {
    name: { required },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/jPopupRename.vue